import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    backdrop-filter: blur(20px);
`;

const Card2 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props.backgroundColor || (props.content && props.content.backgroundColor);
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);

    // Separate media and content items
    const contentItems = items?.filter(item => item.__typename !== "ContentfulMedia") || [];

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            className={`card1 flex-1 flex  justify-start  ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            {contentItems.length > 0 && (
                <div className={`w-full card2__content [&>div:first-child]:bg-gradient-card-header [&>div:first-child]:px-[48px] [&>div:first-child]:py-[24px] [&>div:first-child]:rounded-top_48 [&>div:not(:first-child)]:py-[24px] [&>div:not(:first-child)]:px-[32px]`}>
                    {contentItems.map(item => (
                        <MapTo key={item.id} items={item} />
                    ))}
                </div>
            )}
        </StyledContainer>
    );
};

export default Card2; 